import React from 'react';

import Button from './../Button';
import FormGroup from './../FormGroup';
import ConfirmButtons from './ConfirmButtons';

import Translator from './../../requests/apa/Translator';
import UtilsPagos from "../../utils/payway/UtilsPagos";

import { showModal, MODAL_DROPDOWN } from '../../actions/modal';
import store from '../../store';

const HubBidirectional = ({ labels, paywayChange, setCurrentKey, setRadioValue, currentValues, onAccept, onCancel, onFieldError, errors, workflowInfo, gateway, validateForm, currentStep, accountData }) => {

  let servicesOptions = [];
  let serviceSelected = Translator.get('payment_hubfacturafijagate_combo_services', 'Selecciona el servicio al que se hará el cargo');
  const inputMovil = "account";
  const dropDownService = "serviceId";

  if (accountData && currentStep > 1) {
    servicesOptions = accountData.map((item) => {
      return {
        option: `${item.service_id} - ${item.service_name}`, value: item.service_id
      }
    });
    if (currentValues[dropDownService]) {
      serviceSelected = accountData.find(service => service.service_id == currentValues[dropDownService]);
      if (serviceSelected) {
        serviceSelected = `${serviceSelected.service_id} - ${serviceSelected.service_name}`;
      }
    }
  }

  const showServices = () => {
    setCurrentKey(dropDownService);
    const modal = {
      modalType: MODAL_DROPDOWN,
      modalProps: {
        options: servicesOptions,
        scrollable: false,
        service: (selected) => {
          setRadioValue(dropDownService, selected);
          setCurrentKey(inputMovil);
        },
        type: 'lang'
      }
    }
    store.dispatch(showModal(modal));
  }

  return (
    <div>
      <div className='gatewayTitle'>
        <span>{workflowInfo.gatewaytext}</span>
        <Button className='button positionButtonTop' text={Translator.get('btn_change_payment', 'Cambiar')} onClick={paywayChange} />
      </div>
      <div className='gatewayForm positionFormTop'>
        <div className='row'>
          <FormGroup
            id={inputMovil}
            value={currentValues[inputMovil]}
            error={errors[inputMovil]}
            message={errors[inputMovil] ? errors[inputMovil] : ''}
            placeholder={labels.placeHolderAccount}
            onFocused={() => {
              setCurrentKey(inputMovil);
            }} />
        </div>
        {currentStep > 1 &&
        <div>
          <div className='row'>
            <Button className='button large'
                    iconClassName='fa fa-angle-down fa-lg'
                    order={['text', 'icon']}
                    text={serviceSelected}
                    onClick={showServices}
            />
          </div>
          <div className='row thin' >
            <div className={`msg error`}>
              {errors[dropDownService]}
            </div>
          </div>
        </div>
        }
      </div>
      <ConfirmButtons
        onCancel={() => {
          onCancel(this);
        }}
        onAccept={() => {
          let excludeFields = [];

          if (currentStep === 1) {
            excludeFields.push('serviceId')
          }

          if (validateForm(currentValues, errors, excludeFields)) {
            onAccept(gateway);
          }
        }}
      />
    </div>
  )
}
export default HubBidirectional



// WEBPACK FOOTER //
// ./src/components/Payment/HubBidirectional.jsx